import * as React from 'react';
import { ResponsibleForUnitPanelProps } from './types';
import { ResponsibleForUnitContainer } from 'app/area/user-profile/subscriptions/responsible-for-unit-panel/responsible-for-unit-container';

export const ResponsibleForUnitPanel: React.FC<ResponsibleForUnitPanelProps> = (props) => {
  const { valueItems, formName, validation, translation } = props;

  return <>
    {valueItems?.length > 0
      ? <ResponsibleForUnitContainer
        valueItems={valueItems}
        validation={validation?.[formName]}
        translation={translation} />
      : <p className="no-content">{translation.no_responsible_for_unit}</p>}
  </>;
};
